<template>
  <div id="appointment" class="why-choose-wrap style2 ptb-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="wh-content">
            <div class="content-title style1">
              <span>Get To Know Us</span>
              <h2>We Have A Simple Solution For Your Physical Problem</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem has standard dummy text ever since the 1500s,
                when an unknown printer of type.
              </p>
            </div>
            <div class="feature-item-wrap style2">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-clinic"></i>
                </div>
                <div class="feature-text">
                  <h3>Gastroenterologist</h3>
                  <p>
                    It is a long established fact that reader will be
                    distracted.
                  </p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-stethoscope"></i>
                </div>
                <div class="feature-text">
                  <h3>Plastic Surgeons</h3>
                  <p>
                    It is a long established fact that reader will be
                    distracted.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="300"
        >
          <div class="book-appointment style2">
            <h5>Book An Online Appointment</h5>
            <form action="#">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" placeholder="Full Name" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" placeholder="Email Address" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="number" placeholder="Phone Number" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Booking Date"
                      onfocus="(this.type='date')"
                      onblur="(this.type='text')"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <select name="dept" id="dept">
                      <option data-display="Select Department" value="0">
                        Department
                      </option>
                      <option value="1">Dental Health</option>
                      <option value="2">Physical Health</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <select name="doc" id="doc">
                      <option data-display="Select Doctor" value="0">
                        Select Doctor
                      </option>
                      <option value="1">Dr. Josef Henry</option>
                      <option value="2">Dr. Kevin Martin</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <select name="location" id="location">
                      <option data-display="Select Location" value="0">
                        Select Location
                      </option>
                      <option value="1">South Arizona</option>
                      <option value="2">Florida</option>
                    </select>
                  </div>
                </div>
                <div class="ccol-md-12">
                  <div class="form-group">
                    <textarea
                      name="msg_2"
                      id="msg_2"
                      cols="30"
                      rows="10"
                      placeholder="Message"
                    ></textarea>
                  </div>
                </div>
                <div class="col-12">
                  <button type="submit" class="btn style2">
                    Book An Appointment
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GetToKnowUs",
};
</script>